<div class="calendar-container" fxLayout="column" fxLayoutGap="15px">
  <!-- Search Section -->
  <div class="full-width py-2" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon>search</mat-icon>
      <span class="subtitle-default">Quick Date Selection</span>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
      <div class="search-form full-width">
        <mat-form-field class="custom-date-picker full-width" appearance="outline" floatLabel="always"
                        style="width: 200px;">
          <mat-label>Start Date</mat-label>
          <input [(ngModel)]="searchDatesControl.start" [matDatepicker]="startPicker"
                 matInput
                 placeholder="yyyy/mm/dd"
          />
          <mat-datepicker-toggle matIconSuffix [for]="startPicker">
            <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="custom-date-picker full-width" appearance="outline" floatLabel="always"
                        style="width: 200px;">
          <mat-label>End Date</mat-label>
          <input [(ngModel)]="searchDatesControl.end" [matDatepicker]="endPicker"
                 matInput
                 placeholder="yyyy/mm/dd"
          />
          <mat-datepicker-toggle matIconSuffix [for]="endPicker">
            <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <button class="button-primary search-button full-width" color="primary" mat-flat-button
                (click)="onSelectDateRange()">
          <mat-icon>search</mat-icon>
          <div class="button-text">Select Dates</div>
        </button>
      </div>
    </div>
  </div>

  <div class="calendar-layout">
    <!-- Calendar -->
    <lib-booking-calendar #calendar
                          [bookButtonLabel]="'Book Selected Dates'"
                          [dateConfigs]="dateConfigs"
                          [preSelectedDates]="preSelectedDates"
                          [disableUnavailableDates]="false"
                          [disableConfirm]="disableConfirm"
                          [gridDataLoading]="loadingSpaceData"
                          (focusDateChange)="focusMonthChanged.emit($event)"
                          (dateSelectionChange)="onDateSelectionChange($event)"
                          (confirmSelected)="onBookSelected()"
                          [(initGrid)]="initGrid"
    ></lib-booking-calendar>

    <!--    Right Side panel-->

    <div class="info-card p-3 pt-2 spaces-container" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="20px">
      <mat-tab-group (selectedTabChange)="switchTabs($event)" [(selectedIndex)]="selectedTabIndex"
                     class="custom-tab-group-badge full-width" fxLayoutGap="15px"
                     [preserveContent]="true">
        <mat-tab>
          <ng-template mat-tab-label>
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
              <div class="square-icon icon-smaller">
                <mat-icon class="material-icons-outlined">event_available</mat-icon>
              </div>
              <span class="body-1-default">Available</span>
            </div>
          </ng-template>

          @if (isSubLease) {
            <!-- Available Space -->
            <div class="pt-3" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
              <div class="spaces-header" fxLayout="row" fxLayoutAlign="space-between center">
                <span class="subtitle-default">Reserve Space</span>
              </div>

              <app-shared-space-selection-list class="full-width"
                                        [subLeaseSize]="reservedSpace"
                                        [availableSpace]="availableSharedSpaces"
                                        [warnOnUnavailableSelection]="false"
                                        [listHeight]="availableSpaces.partiallyAvailable.length > 0 ? '412px' : '492px'"
                                        (onSpaceSizeChange)="onSharedSpaceSizeChange($event)">
              </app-shared-space-selection-list>
            </div>
          } @else {
            <!-- Available Spaces -->
            <div class="pt-3" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
              <div class="spaces-header" fxLayout="row" fxLayoutAlign="space-between center">
                <span class="subtitle-default">Available Spaces</span>
              </div>

              <app-space-selection-list class="full-width"
                                        [selectedSpaces]="selectedSpaces"
                                        [availableSpaces]="availableSpaces"
                                        [bookingConfig]="bookingConfig"
                                        [allIndustries]="allIndustries"
                                        [warnOnUnavailableSelection]="false"
                                        [listHeight]="availableSpaces.partiallyAvailable.length > 0 ? '412px' : '492px'"
                                        (onSelectSpace)="onSelectSpace($event)">
              </app-space-selection-list>
            </div>
          }

        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px"
                 [matBadge]="filterOverlappingLeaseSpaces.length > 0 ? filterOverlappingLeaseSpaces.length : null"
                 matBadgeOverlap="true"
                 matBadgeSize="small"
                 matBadgeColor="warn">
              <div class="square-icon icon-smaller">
                <mat-icon class="material-icons-outlined">event_busy</mat-icon>
              </div>
              <span class="body-1-default">Overlapping</span>
            </div>
          </ng-template>

          @if (isSubLease) {
            <div class="pt-3" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
              <div class="spaces-header" fxLayout="row" fxLayoutAlign="space-between center">
                <span class="subtitle-default">Overlapping Sub-Lease Spaces</span>
              </div>

              <div class="spaces-list full-width"
                   [style.height]="'492px'">
                <div *ngFor="let lss of overlappingLeaseSharedSpaces"
                     class="space-item" fxLayout="row" fxLayoutAlign="space-between start">
                  <div class="space-details">
                    <h3>{{ subLease(lss.subLeaseUuid)?.retailerCompanyName }}</h3>
                    <div class="space-info">
                      <mat-icon>crop_square</mat-icon>
                      {{ lss.occupiedSpace }} m²
                    </div>
                    <div class="space-info">
                      <mat-icon>calendar_today</mat-icon>
                      {{ dateUtils.displayShortDate(subLease(lss.subLeaseUuid)!.leaseStartDate) }}
                      to {{ dateUtils.displayShortDate(subLease(lss.subLeaseUuid)!.leaseEndDate) }}
                    </div>
                  </div>
                  <div class="space-pricing partial-spacing" fxLayout="column" fxLayoutAlign="start end"
                       fxLayoutGap="5px">
                    <mat-chip class="m-0" style="height: 24px;" color="primary">
                      <span class="body-1-default">{{ displayStatus(subLease(lss.subLeaseUuid)?.leaseStatus!) }}</span>
                    </mat-chip>
                    <button mat-icon-button (click)="openSubLeaseViewTab(subLease(lss.subLeaseUuid))">
                      <mat-icon color="primary">open_in_new</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <!-- Overlapping Lease Spaces -->
            <div class="pt-3" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
              <div class="spaces-header" fxLayout="row" fxLayoutAlign="space-between center">
                <span class="subtitle-default">Overlapping Lease Spaces</span>
              </div>

              <div class="spaces-list full-width"
                   [style.height]="'492px'">
                <div *ngFor="let lgs of filterOverlappingLeaseSpaces"
                     class="space-item" fxLayout="row" fxLayoutAlign="space-between start">
                  <div class="space-details">
                    <h3>{{ lgs.retailerCompanyName }}</h3>
                    <div class="space-info">
                      <mat-icon>crop_square</mat-icon>
                      {{ lgs.spaceName }}
                    </div>
                    <div class="space-info">
                      <mat-icon>calendar_today</mat-icon>
                      {{ dateUtils.displayShortDate(lgs.leaseStartDate) }}
                      to {{ dateUtils.displayShortDate(lgs.leaseEndDate) }}
                    </div>
                  </div>
                  <div class="space-pricing partial-spacing" fxLayout="column" fxLayoutAlign="start end"
                       fxLayoutGap="5px">
                    <mat-chip class="m-0" style="height: 24px;" color="primary">
                      <span class="body-1-default">{{ displayStatus(lgs.leaseStatus!) }}</span>
                    </mat-chip>
                    <button mat-icon-button (click)="openLeaseViewTab(lgs)">
                      <mat-icon color="primary">open_in_new</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }

        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
